module.exports = __webpack_public_path__ + "static/media/wetherspoon.c850e9cf.png";